import React from "react";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import "../styles/Footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer">
      <div className="socialMedia">
        <InstagramIcon
          type="button"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = 'https://www.instagram.com/pushpit_gill_arts/';
          }}
        ></InstagramIcon>
       
       <YouTubeIcon
          type="button"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = 'https://www.youtube.com/channel/UC6Bjm7_zK6wWLcMySNYIsmA/videos';
          }}
        ></YouTubeIcon>
        <FacebookIcon
          type="button"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = 'https://facebook.com/PushpitGillArts/';
          }}
        ></FacebookIcon>
        <LinkedInIcon
          type="button"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = 'https://linkedin.com/in/pushpitgill123';
          }}
        ></LinkedInIcon>

      </div>
      <p> &copy; 2022 Pushpitgillarts.com</p>
    </div>
  );
}

export default Footer;
